import { useTranslation } from '@/hooks/use-translation'

interface PaginationInfoProps {
  startRow: number
  endRow: number
  totalItems: number
  currentPage: number
  totalPages: number
}

/**
 * Component for displaying pagination information (e.g., "1-5 of 20 elements", "Page 1 of 4").
 */
export function PaginationInfo({
  startRow,
  endRow,
  totalItems,
  currentPage,
  totalPages,
}: PaginationInfoProps) {
  const t = useTranslation()

  return (
    <>
      <div className="text-muted-foreground flex-1 text-xs">
        {totalItems > 0 ? (
          <>
            {startRow}-{endRow} {t('dataTable.of')} {totalItems} {t('dataTable.elements')}
          </>
        ) : (
          `0 ${t('dataTable.elements')}`
        )}
      </div>
      <div className="flex w-[120px] items-center justify-center text-xs font-medium">
        {t('dataTable.page')} {currentPage} {t('dataTable.of')} {totalPages}
      </div>
    </>
  )
}
